<app-header>
   <jbm-view-title [caption]="'entity.resources'|translate" [parentLinkCaption]="'menu.settings'|translate"
      [itemcount]="queryHttpHelper.paginationProps.itemCount" [parentLinkSlug]="'settings'">
   </jbm-view-title>
   <jbm-create-button [visible]="userRights.AllowCreate" [className]="'float-start'"
      (click)="create()">
   </jbm-create-button>
   <div class="toolbar float-start ml-4">
      <div class="toolbar-spacer-2"></div>
      <label>{{'entity.type'|translate}}</label>
      <select (change)="changeType($event)" class="form-control form-control-sm form-select">
         <option *ngFor="let type of typeOptions" value="{{type.key}}">{{type.value}}</option>
      </select>
   </div>
   <div class="toolbar float-end">
      <jbm-pagination [itemCount]="queryHttpHelper.paginationProps.itemCount"
         [pageSize]="queryHttpHelper.paginationProps.pageSize" [page]="queryHttpHelper.paginationProps.page"
         (pageClick)="pageChange($event)">
      </jbm-pagination>
      <jbm-searchbox [search]="queryHttpHelper.getSearchValue()" [minlength]="1" 
         (searchChange)="searchChange($event)">
      </jbm-searchbox>
      <jbm-help-button [helpTopicID]="0"></jbm-help-button>
   </div>
</app-header>
<section class="module resources">
   <jbm-table #table [absolute]="false" [data]="items" [sortable]="true" [sortColumn]="queryHttpHelper.sortProps.name"
      [sortDirection]="queryHttpHelper.sortProps.direction" [hoverable]="true" [rowSelectable]="userRights.AllowRead"
      [columnDefs]="columnDefs" [classname]="'padding'" (rowCountChange)="rowCountChange($event)" 
      (sortChange)="sortChange($event)" (rowSelect)="edit($event)">
   </jbm-table>
   <ng-template #plantsTemplate let-data="data">
      <div class="btn btn-light btn-sm" [ngbTooltip]="plants" [container]="'body'" placement="right">
        <i class="fa fa-industry"></i>
      </div>      
      <ng-template #plants>
         <div class="fw-bold">{{'company.plants'|translate}}</div>
         <div *ngFor="let plant of data.plants">
            {{plant.name}}
         </div>
      </ng-template>   
   </ng-template>
</section>

<jbm-toasts></jbm-toasts>

<ng-template #actionsTemplate let-data="data">
    <button *ngIf="userRights.AllowUpdate" type="button" class="btn btn-primary btn-sm float-start mr-1" (click)="edit(data.id);$event.stopPropagation()"><i class="far fa-edit"></i></button>
  <jbm-confirm-delete-dropdown *ngIf="data.remove_allowed" [tooltipPlacement]="'left'" [placement]="'bottom-right'"
    subject="Grondstof verwijderen" (onConfirm)="remove(data.public_id)">
  </jbm-confirm-delete-dropdown>
</ng-template>

<jbm-modal [id]="'resource'" [className]="'resource'"></jbm-modal>
<ng-template #modalResource let-modal>
   <resource-form [id]="public_id" [types]="types" (onSave)="resourceSaved()" (onCancel)="resourceCancelled()"></resource-form>
</ng-template>